'use client';

import { useMemo } from 'react';
import { useWishlistSafe } from './use-wishlist-safe';

/**
 * Hook to get the default wishlist for the user.
 * No longer automatically creates a default list to prevent race conditions.
 * Use useAddToDefaultWishlist for adding items with automatic list creation.
 */
export function useDefaultWishlist() {
  const wishlistContext = useWishlistSafe();

  const contextData = useMemo(() => {
    if (!wishlistContext) {
      return {
        lists: null,
        loading: false,
      };
    }
    return {
      lists: wishlistContext.lists,
      loading: wishlistContext.loading,
    };
  }, [wishlistContext]);

  // Return disabled state if wishlist is not available
  if (!wishlistContext) {
    return {
      defaultList: null,
      hasLists: false,
      isReady: false,
    };
  }

  const defaultList = contextData.lists?.[0] || null;
  const hasLists = Boolean(contextData.lists?.length);
  const isReady = !contextData.loading;

  return {
    defaultList,
    hasLists,
    isReady,
  };
}
